import React from 'react';
import useEvaEntryExperiment from 'utils/hooks/useEvaEntryExperiment';

import ElevenLabsTracker from './ElevenLabsTracker/ElevenLabsTracker';
import ElevenLabsWidgetLoader from './ElevenLabsWidgetLoader';

type EvaEntryExperimentGateProps = {
  children: React.ReactNode;
};

export default function EvaEntryExperimentGate({
  children,
}: EvaEntryExperimentGateProps): JSX.Element {
  const { isReady, isWidgetVariant } = useEvaEntryExperiment();
  const shouldLoadWidget = isReady && isWidgetVariant;

  if (!shouldLoadWidget) {
    return <>{children}</>;
  }

  return (
    <ElevenLabsTracker>
      <>
        {children}
        <ElevenLabsWidgetLoader />
      </>
    </ElevenLabsTracker>
  );
}
